import { RefactorStepper } from "../../components/refactor/RefactorStepper";

export default function RefactorPage(): JSX.Element {
  return <RefactorStepper />;
}
